var _defs, _path, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1703.49 637.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-2{font-family:Poppins-Bold, Poppins;font-weight:700;}.cls-2,.cls-3{font-size:330px;}.cls-3{font-family:Poppins-Regular, Poppins;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m204.7,238.05c-4.9,15.2-8.4,30.9-10.5,47.1C84.6,270.55,0,176.75,0,63.15,0,45.45,14.3,31.15,32,31.15h24c85.5,0,159.9,48,197.7,118.4-12.2,14.5-22.8,30.3-31.6,47.1-24.1-68.4-89.4-117.5-166.1-117.5h-7.3c7.6,83.4,73.1,149.9,156,159v-.1Zm251.3-94.9c-97.2,0-176,78.8-176,176h0v16h8c97.2,0,176-78.8,176-176v-16h-8Zm0-48h24c17.7,0,32,14.3,32,32v32c0,123.7-100.3,224-224,224h-8v136c0,13.3-10.7,24-24,24s-24-10.7-24-24v-200c0-123.7,100.3-224,224-224Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", null)), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(567.31 537.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pantry"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(567.25 280.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "this"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.a25f7bb320a12eea378bb57e27200c29.svg";
export { ForwardRef as ReactComponent };